import { combineReducers } from 'redux';

import childcare from './childcare/childcare.reducer';
import packageUpsell from './package-upsell/packageUpsell.reducer';

export default combineReducers({
  childcare,
  packageUpsell,
});
